// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3YqbM","footer":"ReportModalFilter_footer__SIJuv"};